<template>
  <main-template>
    <v-container>
      <v-row align="center" class="mb-1">
        <v-col>
          <h1>
            <v-btn color="primary" x-small text @click="$router.go(-1)">
              <v-icon left>fa fa-angle-left</v-icon>
            </v-btn>
            Gerenciar Avisos
          </h1>
        </v-col>
        <v-col cols="auto">
          <v-btn color="primary" @click="abrirModalNovo">
            <v-icon left>mdi-plus</v-icon>
            Novo Aviso
          </v-btn>
        </v-col>
      </v-row>

      <v-card class="elevation-2">
        <v-data-table
          :headers="headers"
          :items="avisos"
          :loading="carregando"
          no-data-text="Nenhum aviso cadastrado."
          loading-text="Carregando avisos..."
          class="elevation-0"
        >
          <template v-slot:item.imagem="{ item }">
            <v-avatar size="40" v-if="item.imagem">
              <img :src="obterUrlImagem(item.imagem)" alt="Aviso" />
            </v-avatar>
            <span v-else class="grey--text text-caption">Sem imagem</span>
          </template>

          <template v-slot:item.destinatarios="{ item }">
            <v-chip v-if="item.todos_colaboradores" color="primary" text-color="white" small>
              Todos
            </v-chip>
            <v-chip v-else color="secondary" text-color="white" small>
              {{ item.destinatarios ? item.destinatarios.length : 0 }} Colaborador(es)
            </v-chip>
          </template>

          <template v-slot:item.ativo="{ item }">
            <v-switch
              v-model="item.ativo"
              color="success"
              hide-details
              class="ma-0"
              @change="alternarStatus(item)"
            />
          </template>

          <template v-slot:item.acoes="{ item }">
            <v-btn icon color="error" @click="confirmarExclusao(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="dialogNovo" max-width="600px" persistent>
        <v-card>
          <v-card-title class="headline primary white--text py-4">
            Novo Aviso Importante
          </v-card-title>

          <v-card-text class="pt-4">
            <v-form ref="formNovo" v-model="formValido" lazy-validation>
              <v-text-field
                v-model="form.titulo"
                label="Título"
                outlined
                dense
                required
                :rules="[(v) => !!v || 'Título é obrigatório']"
              />

              <v-textarea
                v-model="form.conteudo"
                label="Conteúdo (Mensagem)"
                outlined
                dense
                required
                rows="4"
                :rules="[(v) => !!v || 'Conteúdo é obrigatório']"
              />

              <v-file-input
                v-model="form.imagemFile"
                label="Imagem (Opcional)"
                outlined
                dense
                accept="image/*"
                prepend-icon="mdi-camera"
                show-size
                :rules="[
                  (v) => !v || v.size < 2 * 1024 * 1024 || 'A imagem não pode ser maior que 2MB',
                ]"
              />

              <v-radio-group v-model="form.todos_colaboradores" row class="mt-0">
                <v-radio :value="true" label="Todos os Colaboradores" />
                <v-radio :value="false" label="Colaboradores Específicos" />
              </v-radio-group>

              <v-autocomplete
                v-if="!form.todos_colaboradores"
                v-model="form.destinatarios"
                :items="colaboradores"
                item-text="name"
                item-value="id"
                label="Selecionar Colaboradores"
                multiple
                chips
                deletable-chips
                outlined
                dense
                required
                :rules="[
                  !form.todos_colaboradores && form.destinatarios.length === 0
                    ? 'Selecione pelo menos um colaborador'
                    : true,
                ]"
              />
            </v-form>
          </v-card-text>

          <v-card-actions class="pb-4 px-6">
            <v-spacer />
            <v-btn text color="grey darken-2" @click="dialogNovo = false"> Cancelar </v-btn>
            <v-btn
              color="primary"
              :disabled="!formValido || enviando"
              :loading="enviando"
              @click="salvarAviso"
            >
              Salvar Aviso
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogConfirmarExclusao" max-width="400px">
        <v-card>
          <v-card-title class="headline error white--text py-3"> Confirmar Exclusão </v-card-title>
          <v-card-text class="pt-4">
            Deseja realmente excluir o aviso <strong>"{{ avisoParaExcluir?.titulo }}"</strong>? Esta
            ação não pode ser desfeita.
          </v-card-text>
          <v-card-actions class="pb-3 px-4">
            <v-spacer />
            <v-btn text @click="dialogConfirmarExclusao = false">Cancelar</v-btn>
            <v-btn color="error" @click="excluirAviso">Excluir</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </main-template>
</template>

<script>
export default {
  name: "GerenciarAvisosPage",
  data() {
    return {
      avisos: [],
      colaboradores: [],
      carregando: false,
      enviando: false,
      dialogNovo: false,
      dialogConfirmarExclusao: false,
      formValido: true,
      avisoParaExcluir: null,
      headers: [
        { text: "Imagem", value: "imagem", sortable: false, width: "80px" },
        { text: "Título", value: "titulo" },
        { text: "Criado Por", value: "criador.name" },
        { text: "Destinatários", value: "destinatarios", width: "160px" },
        { text: "Ativo", value: "ativo", sortable: false, width: "100px" },
        { text: "Ações", value: "acoes", sortable: false, width: "80px" },
      ],
      form: {
        titulo: "",
        conteudo: "",
        imagemFile: null,
        todos_colaboradores: true,
        destinatarios: [],
      },
    };
  },
  mounted() {
    this.carregarAvisos();
    this.carregarColaboradores();
  },
  methods: {
    async carregarAvisos() {
      try {
        this.carregando = true;
        const res = await this.$services.colaboradorAvisoService.listarAvisosAdmin();
        this.avisos = res.data || [];
      } catch (error) {
        this.$toast.danger("Erro ao carregar avisos.");
      } finally {
        this.carregando = false;
      }
    },
    async carregarColaboradores() {
      try {
        this.colaboradores = await this.$services.colaboradorPontosService.listarColaboradores();
      } catch (error) {
        /* eslint-disable-next-line no-console */
        console.error("Erro ao carregar colaboradores:", error);
      }
    },
    abrirModalNovo() {
      this.form = {
        titulo: "",
        conteudo: "",
        imagemFile: null,
        todos_colaboradores: true,
        destinatarios: [],
      };
      this.dialogNovo = true;
      this.$nextTick(() => {
        if (this.$refs.formNovo) {
          this.$refs.formNovo.resetValidation();
        }
      });
    },
    obterUrlImagem(path) {
      if (!path) return "";
      const filename = path.split("/").pop();
      const token = localStorage.getItem("access_token") || "";
      return `${process.env.VUE_APP_API_HOST}colaborador-avisos/uploads/${filename}?token=${token}`;
    },
    async alternarStatus(item) {
      try {
        await this.$services.colaboradorAvisoService.alternarStatus(item.id, item.ativo);
        this.$toast.success(`Aviso ${item.ativo ? "ativado" : "desativado"} com sucesso.`);
      } catch (error) {
        item.ativo = !item.ativo;
        this.$toast.danger("Erro ao alternar status do aviso.");
      }
    },
    confirmarExclusao(item) {
      this.avisoParaExcluir = item;
      this.dialogConfirmarExclusao = true;
    },
    async excluirAviso() {
      try {
        await this.$services.colaboradorAvisoService.excluirAviso(this.avisoParaExcluir.id);
        this.$toast.success("Aviso excluído com sucesso.");
        this.dialogConfirmarExclusao = false;
        this.carregarAvisos();
      } catch (error) {
        this.$toast.danger("Erro ao excluir aviso.");
      }
    },
    async salvarAviso() {
      if (!this.$refs.formNovo.validate()) return;
      try {
        this.enviando = true;
        const formData = new FormData();
        formData.append("titulo", this.form.titulo);
        formData.append("conteudo", this.form.conteudo);
        formData.append("todos_colaboradores", this.form.todos_colaboradores ? "1" : "0");

        if (this.form.imagemFile) {
          formData.append("imagem_file", this.form.imagemFile);
        }

        if (!this.form.todos_colaboradores) {
          formData.append("destinatarios", JSON.stringify(this.form.destinatarios));
        }

        await this.$services.colaboradorAvisoService.criarAviso(formData);
        this.$toast.success("Aviso criado com sucesso.");
        this.dialogNovo = false;
        this.carregarAvisos();
      } catch (error) {
        this.$toast.danger("Erro ao criar aviso.");
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>

<style scoped>
.primary--text {
  color: var(--brand) !important;
}
</style>
